import {ApiClient} from './api_client';
import {omitNullsy} from './api_utils';

type ExportOptions = {
  url: string;
  filters: Record<string, any>;
  locale: string;
  fallbackFilename: string;
  openInNewTab?: boolean;
};
type ExportOptionsWithoutFilename = Omit<ExportOptions, 'fallbackFilename'> & {fallbackFilename?: string};
export const ExportUtils = {
  handleExportPdf(options: ExportOptionsWithoutFilename) {
    return this.handleExport({...options, fallbackFilename: options.fallbackFilename ?? 'export.pdf'});
  },
  handleExportXlsx(options: ExportOptionsWithoutFilename) {
    return this.handleExport({...options, fallbackFilename: options.fallbackFilename ?? 'export.xlsx'});
  },
  handleExport(options: ExportOptions) {
    const {url, filters, locale, fallbackFilename} = options;
    const queryParams = new URLSearchParams(omitNullsy(filters));
    queryParams.set('language', locale.toUpperCase());
    const fullUrl = `${url}?${queryParams.toString()}`;

    // Returned so the caller can tell the user when the export fails; without it a rejected request left the
    // screen unchanged and the click looked like it had done nothing.
    return ApiClient.getInstance(true)
      .get(fullUrl, {
        responseType: 'blob',
      })
      .then((response) => {
        const filename = this.getFilenameFromHeader(response.headers['content-disposition'] ?? '', fallbackFilename);

        if (options.openInNewTab) {
          const url = window.URL.createObjectURL(response.data);
          window.open(url, '_blank');

          setTimeout(() => window.URL.revokeObjectURL(url), 100);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      });
  },
  getFilenameFromHeader(contentDisposition: string, fallbackFilename: string) {
    let match = contentDisposition.match(/filename="([^"]+)"/);
    if (match) return match[1];
    match = contentDisposition.match(/filename=([^;]+)/);
    if (match) return match[1];
    return fallbackFilename;
  },
};
